import React from 'react';
import PropTypes from 'prop-types';

function cell({ cell: { value: initialValue } }) {
  return <div style={{ textAlign: 'center' }}>{initialValue.length}</div>;
}

cell.propTypes = {
  cell: PropTypes.object,
};

export default cell;
